import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class AuthenticatedAdminReportingReportViewerController extends Controller {
  queryParams = ['reportId', 'companyId'];

  @tracked reportId?: string;
  @tracked companyId?: string;
}
